import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { debounce, distinctUntilChanged, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingService implements OnDestroy {
  private readonly loadingSubject$ = new BehaviorSubject<boolean>(false);
  private loadingCounter = 0;

  get isLoading$(): Observable<boolean> {
    return this.loadingSubject$.asObservable().pipe(
      debounce(() => timer(0)),
      distinctUntilChanged()
    );
  }

  start(): void {
    this.loadingCounter++;
    if (this.loadingCounter === 1) {
      this.loadingSubject$.next(true);
    }
  }

  end(): void {
    this.loadingCounter--;
    if (this.loadingCounter < 0) {
      this.loadingCounter = 0;
    }
    if (this.loadingCounter === 0) {
      this.loadingSubject$.next(false);
    }
  }

  ngOnDestroy(): void {
    this.loadingSubject$.complete();
  }
}
